import React, { useEffect, useState } from 'react';
import { TextField, Button, Checkbox, Link, Typography, IconButton, FormControlLabel, InputAdornment, CircularProgress } from "@mui/material";
import { createTheme } from '@mui/material/styles';
import RudderLogo from '../../img/Starlight Logo.png';
import RightBG from '../../img/right_bg.jpg'
import { useNavigate } from "react-router-dom";
import { Email } from '@mui/icons-material';
import axios from 'axios';
import { toast } from 'react-toastify';
import API from '../../api';
import { useDispatch } from "react-redux";
import { setRoleWiseMenu } from "../../features/roleWiseMenuSlice";
import { fetchSitesByOrganization } from "../../features/siteSlice";


function LoginPage(props) {
    const theme = createTheme();
    const history = useNavigate();
    const dispatch = useDispatch();
    const [formErrors, setFormErrors] = React.useState({ username: '', password: '', })
    const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberMe') ? localStorage.getItem('rememberMe') === 'true' ? true : false : false);
    const token = localStorage.getItem('token')
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const validateloginForm = (e) => {
        const errors = {};
        setFormErrors(errors);
        const data = new FormData(e.currentTarget);
        let hasError = 0;
        // Validation for username
        if (!data.get('username')?.trim()) {
            toast.error('username field is required', { autoClose: 3000, theme: "colored" })
            hasError = 1;
            errors['username'] = 1
        } else if (data.get('username').length > 255) {
            toast.error('username should be less than 255 characters', { autoClose: 3000, theme: "colored" })
            hasError = 1;
            errors['username'] = 1
        } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i.test(data.get('username'))) {
            toast.error('Invalid username Format', { autoClose: 3000, theme: "colored" })
            hasError = 1;
            errors['username'] = 1
        }
        if (!data.get('password')?.trim()) {
            toast.error('Password field is required', { autoClose: 3000, theme: "colored" })
            hasError = 1;
            errors['password'] = 1
        } else if (data.get('password').length > 255) {
            toast.error('Password should be less than 255 characters', { autoClose: 3000, theme: "colored" })
            hasError = 1;
            errors['password'] = 1
        }
        setFormErrors(errors);
        // Check if there are any errors
        return (hasError > 0) ? false : true;
    };
    const handleSubmit = async (event) => {
        const data = new FormData(event.currentTarget);

        let username = data.get('username');
        let password = data.get('password');
        let rememberMe = data.get('rememberMe');
        event.preventDefault();
        if (validateloginForm(event)) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, { username, password, rememberMe });
                if (response.data.statuscode === 200) {
                    if (response.data.token) {
                        if (rememberMe) {
                            localStorage.setItem('username', username);
                            localStorage.setItem('username', username);
                            localStorage.setItem('password', password);
                            localStorage.setItem('rememberMe', rememberMe);
                        } else {
                            localStorage.removeItem('rememberMe');
                            localStorage.removeItem('username');
                            localStorage.removeItem('password');
                        }
                        localStorage.setItem('token', response.data.token)
                        localStorage.setItem('user_id', response.data.user_id)
                        const { data } = await API({ method: 'get', url: 'role-wise-menu/' + response.data.role });
                        if (data.status_code === 200) {
                            if (data && data.data) {
                                let menus = data.data
                                dispatch(setRoleWiseMenu(data.data))
                            } else {
                                dispatch(setRoleWiseMenu([]))
                            }
                        }
                        dispatch(
                            fetchSitesByOrganization({
                                organization_id: "693aad7d46cfa15970cb01d5",
                                page: 1,
                                limit: 20,
                            })
                        );
                        localStorage.setItem('username', username);
                        localStorage.setItem('user_role', response.data.role);
                        history('/dashboard', { replace: true })
                    }
                } else {
                }
            } catch (error) {
                toast.error(error.message === "Network Error" ? "Something went wrong,login after sometime" : error.response.data.message, { autoClose: 3000, theme: "colored" })
            }
        }
    };
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        let rememberMe = localStorage.getItem('rememberMe') ? localStorage.getItem('rememberMe') === 'true' ? true : false : false;
        setRememberMe(rememberMe)
        if (storedToken != null) {
            axios.post(`${process.env.REACT_APP_API_URL}/api/validate-token`, { token: storedToken }).then((res) => {
                if (res.status === 200) {
                    history('/dashboard', { replace: true })
                } else {
                    history('/', { replace: true })
                }
            }).catch(error => {
                // Handle error.
                console.log('An error occurred:', error.response);
            });
        } else {
            history('/', { replace: true })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    return (
        <main>
            <div className='row m-0 p-0' style={{ height: "100vh" }} id='test'>
                <div className='col-md-12 col-sm-12'>
                    <div className='container h-100'>
                        <div className='row h-100'>
                            <div className='col-md-4 col-sm-12 mx-auto h-100 align-items-start justify-content-center d-flex flex-column'>
                                <img className="mb-0" height={70} alt='' src={RudderLogo} />
                                <Typography className="mb-1" variant="h5" fontWeight={600}>
                                    Welcome Back
                                </Typography>

                                {/* <Typography className='mb-3' variant="body2" color={theme.palette.grey[700]}>
                                    Don't have an account yet? <Link href="signup" className='' fontWeight={600}>Sign up now</Link>
                                </Typography> */}
                                <form onSubmit={handleSubmit}  >
                                    <TextField
                                        margin="normal"
                                        fullWidth
                                        error={(formErrors?.username) ? true : false}
                                        id="username"
                                        label="Email Address"
                                        name="username"
                                        autoComplete="username"
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                >
                                                    <Email />
                                                </IconButton>
                                            ),
                                        }}
                                    />

                                    <TextField
                                        label="Password"
                                        fullWidth
                                        // error
                                        margin="normal"
                                        error={(formErrors?.password) ? true : false}
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        helperText=""
                                        InputProps={{
                                            endAdornment: (<InputAdornment position="end"><IconButton onClick={handleClickShowPassword}><i className={showPassword ? "ri-eye-line" : 'ri-eye-off-line'}></i></IconButton></InputAdornment>),
                                        }}
                                        id="reddit-input"
                                        variant="filled"
                                    />
                                    {/* <div className='w-100 d-flex align-items-center justify-content-between'>
                                        <FormControlLabel
                                            control={<Checkbox name="rememberMe" value="1" color="primary" />}
                                            label="Remember me"
                                        />

                                        <Link href="forgot-password" className='' fontWeight={600}>Forgot Password?</Link>

                                    </div> */}

                                    <Button
                                        type="submit"
                                        fullWidth
                                        disableElevation
                                        onSubmit={handleSubmit}
                                        // disabled
                                        variant="contained"
                                        size='large'
                                        startIcon={<i className="ri-login-circle-line"></i>}
                                        sx={{ my: 1, borderRadius: 50, }}
                                    >
                                        <CircularProgress use="btnloader" size="xsmall" variant='indeterminate' className='me-3 d-none' />
                                        Login
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className='col-md-3 col-sm-12 d-none d-md-block'
                    style={{
                        backgroundImage: `url(${RightBG})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 0,
                        overflow: "hidden"
                    }}
                >

                </div> */}
            </div>
        </main>
    );
}

export default LoginPage;